import React from "react";
import {
  Typography,
  Grid,
  TextField,
  Button,
  Container,
  FormControl,
} from "@mui/material";
import { Link } from "react-router-dom";

export default function MultiDocs({
  extraDocs,
  onFileChange,
  onDocumentNameChange,
  submit,
  onAddMore,
  t,
}) {
  const acceptedFile = ".pdf, .jpeg, .jpg, .heic, .png";
  return (
    <>
      <Container sx={{ padding: "0px" }}>
        {extraDocs.map((doc, index) => (
          <Grid container key={index}>
            <Grid item xs={12}>
              <TextField
                style={{ marginTop: "20px" }}
                variant="outlined"
                fullWidth
                label={t("Document Name")}
                value={doc.name || ""}
                onChange={(e) => onDocumentNameChange(e, index)}
              />
            </Grid>
            <FormControl
              fullWidth
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "20px",
              }}
            >
              <Grid item xs={7}>
                <Typography>{t("Upload Document")}:</Typography>
                <Typography style={{ fontSize: "10px", fontWeight: 500 }}>
                  (pdf, jpeg, heic, png file Only)
                </Typography>
                {doc.file && <Typography>{doc.file.name}</Typography>}
              </Grid>
              <Grid item xs={5}>
                <input
                  type="file"
                  id="farm-photo"
                  name="farm_photo"
                  accept={acceptedFile}
                  capture="environment"
                  onChange={(e) => onFileChange(e, index)}
                  style={{ display: "none" }}
                />
                <Button
                  variant="contained"
                  component="label"
                  style={{ marginLeft: "auto", color: "white", width: "145px" }}
                  htmlFor="farm-photo"
                >
                  {t("Upload")}
                </Button>
              </Grid>
            </FormControl>
          </Grid>
        ))}

        <Grid container justifyContent="flex-end" marginTop="20px">
          <Grid item>
            <Link onClick={onAddMore} style={{ color: "#4CAF50" }}>
              {t("+Add More")}
            </Link>
          </Grid>
        </Grid>

        <Grid item>
          <Button
            fullWidth
            variant="contained"
            onClick={submit}
            style={{ color: "white", marginTop: "20px" }}
          >
            {t("Submit")}
          </Button>
        </Grid>
      </Container>
    </>
  );
}
